import { createSlice } from "@reduxjs/toolkit";
import { getJSONObject } from "utils/helper";
import { fetchInitialDataThunk } from "slices/initialData/thunk";

const initialState = {
    byKey: {},          // key -> { rows, plotConfig, apiRow, isFilterable, fetchedAt }
    loadingByKey: {},   // key -> boolean
    errorByKey: {},     // key -> string | null
};

function makeKey(arg) {
    if (!arg || !arg.dashboard_id || !arg.chartid) return null;
    return `${arg.dashboard_id}:${arg.chartid}`;
}

const initialDataSlice = createSlice({
    name: "initialData",
    initialState,
    reducers: {
        clearInitialDataForKey: (state, action) => {
            const key = action.payload;
            if (!key) return;
            delete state.byKey[key];
            delete state.loadingByKey[key];
            delete state.errorByKey[key];
        },
        clearAllInitialData: (state) => {
            state.byKey = {};
            state.loadingByKey = {};
            state.errorByKey = {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchInitialDataThunk.pending, (state, action) => {
            const key = makeKey(action.meta?.arg);
            if (!key) return;
            state.loadingByKey[key] = true;
            state.errorByKey[key] = null;
        });
        builder.addCase(fetchInitialDataThunk.fulfilled, (state, action) => {
            const key = makeKey(action.meta?.arg);
            if (!key) return;
            const resp = action.payload;

            // API contract similar to usages in components: resp[0] is array of rows, resp[1] filterable flag
            const r = Array.isArray(resp?.[0]) ? resp[0] : resp?.results ?? [];
            const row = r?.[0] ?? null;
            const df = getJSONObject(row?.updated_df_data ? row.updated_df_data : row?.df_data) || [];
            const hc = getJSONObject(row?.highchart_code) || {};

            state.byKey[key] = {
                rows: Array.isArray(df) ? df : [],
                plotConfig: hc,
                apiRow: row || null,
                isFilterable: Boolean(resp?.[1] || resp?.date_range_filter),
                fetchedAt: Date.now()
            };
            state.loadingByKey[key] = false;
            state.errorByKey[key] = null;
        });
        builder.addCase(fetchInitialDataThunk.rejected, (state, action) => {
            const key = makeKey(action.meta?.arg);
            if (!key) return;
            state.loadingByKey[key] = false;
            state.errorByKey[key] = action.payload || action.error?.message || "Failed to load";
        });
    }
});

export const { clearInitialDataForKey, clearAllInitialData } = initialDataSlice.actions;

export default initialDataSlice.reducer;


